import React from 'react';
import { deleteJourneyDraft, } from '@Api';
import { IAbilities, IAuth, IOrganizationStore, IJourneyStore, } from '@Store';
import { CrudEnum, IPreviewJourneyDraft, PermissionEnum, TJourneyDraftSortableListCol, } from 'atlas-shared';
import { tableColumnDatetimeSorter, tableColumnStringSorter, timeSince, } from '@Utils';
import { TFunction, } from 'i18next';
import { NavigateFunction, } from 'react-router';
import { ColumnsType, } from 'antd/lib/table/interface';
import { listAuditButton, listDeleteButton, listEditButton, GetColumnSearchProps, GetColumnSearchLikeProps, GetColumnSearchEqualProps, } from '../components';
import { IWithListProps, } from '@Hocs/with.list';

export const JourneyDraftListColumns = (t: TFunction, navigate: NavigateFunction, showDeleted: boolean, organizations: IOrganizationStore, journeies: IJourneyStore, abilities: IAbilities, auth: IAuth, buttons: Array<(row: IPreviewJourneyDraft) => React.ReactElement> = [], filters: IWithListProps<IPreviewJourneyDraft, TJourneyDraftSortableListCol>['filters'], sorter: IWithListProps<IPreviewJourneyDraft, TJourneyDraftSortableListCol>['sorter']): ColumnsType<IPreviewJourneyDraft> => {
  return [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'id',
      sorter: (a: IPreviewJourneyDraft, b: IPreviewJourneyDraft) => a.id - b.id,
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'id')?.order || null,
      filteredValue: filters.id || null,
      ...GetColumnSearchEqualProps(t, 'id', t('ID')),
      className: 'table-cell-id',
    },
    auth.user.__admin_organization_ids.length > 1 && {
      title: t('ORGANIZATION'),
      dataIndex: 'organization_id',
      key: 'organization_id',
      render: (organization_id: IPreviewJourneyDraft['organization_id'], journey_draft: IPreviewJourneyDraft) => organizations.dict?.[organization_id]?.title || t('ORGANIZATION_NOT_FOUND', { replace: { organization_id, }, }),
      sorter: (a: IPreviewJourneyDraft, b: IPreviewJourneyDraft) => (organizations.dict?.[a.organization_id]?.title || '').localeCompare(organizations.dict?.[b.organization_id]?.title || ''),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'organization_id')?.order || null,
      filteredValue: filters.organization_id || null,
      ...GetColumnSearchProps(t, 'organization_id', t('ORGANIZATION'), organizations.organizations),
      className: 'table-cell-organization_id',
    },
    {
      title: t('JOURNEY'),
      dataIndex: 'journey_id',
      key: 'journey_id',
      render: (journey_id: IPreviewJourneyDraft['journey_id'], journey_draft: IPreviewJourneyDraft) => journeies.dict?.[journey_id]?.title || t('JOURNEY_NOT_FOUND', { replace: { journey_id, }, }),
      sorter: (a: IPreviewJourneyDraft, b: IPreviewJourneyDraft) => (journeies.dict?.[a.journey_id]?.title || '').localeCompare(journeies.dict?.[b.journey_id]?.title || ''),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'journey_id')?.order || null,
      filteredValue: filters.journey_id || null,
      ...GetColumnSearchProps(t, 'journey_id', t('JOURNEY'), journeies.journeies),
      className: 'table-cell-journey_id',
    },
    {
      title: t('TITLE'),
      dataIndex: 'title',
      key: 'title',
      sorter: (a: IPreviewJourneyDraft, b: IPreviewJourneyDraft) => tableColumnStringSorter(a.title, b.title),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'title')?.order || null,
      filteredValue: filters.title || null,
      ...GetColumnSearchLikeProps(t, 'title', t('TITLE')),
      className: 'table-cell-title',
    },
    {
      title: t('CREATED_AT'),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (created_at: IPreviewJourneyDraft['created_at'], journey_draft: IPreviewJourneyDraft) => <div className='date-column'>{created_at ? timeSince(t, new Date(created_at), true) : ''}</div>,
      sorter: (a: IPreviewJourneyDraft, b: IPreviewJourneyDraft) => tableColumnDatetimeSorter(a.created_at, b.created_at),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'created_at')?.order || null,
      className: 'table-cell-created_at',
    },
    
    {
      title: '',
      dataIndex: 'operation',
      key: 'operation',
      render: (_: any, row: IPreviewJourneyDraft) => (
        <div className={'table-operation-wrp'}>
          {buttons.map(button => button(row))}
          {abilities.can(row.organization_id, CrudEnum.Read, PermissionEnum.Audit, row) && listAuditButton(t, navigate, 'journey_draft', row)}
          {abilities.can(row.organization_id, CrudEnum.Update, PermissionEnum.Journey, row) && listEditButton(t, navigate, 'journey_draft', row)}
          {abilities.can(row.organization_id, CrudEnum.Delete, PermissionEnum.Journey, row) && listDeleteButton(t, row, deleteJourneyDraft)}
        </div>
      ),
    },
  ].filter(Boolean) as ColumnsType<IPreviewJourneyDraft>;

};
